import { useQuery } from '@tanstack/react-query';

import { getConferences } from '../api';
import { homeQuery } from '../data/query-keys';
import {
  ApiResponse,
  Conference,
  ProcessedApiResponse,
} from '../types/conferences';

const calendarItemColors: string[] = ['#973060', '#045459', '#266AA6'];

export const useConferences = () => {
  return useQuery<ApiResponse, Error, ProcessedApiResponse>({
    queryKey: homeQuery.getConferences,
    queryFn: getConferences,
    staleTime: 5000,
    select: (res) => {
      if (!res?.conferences?.length) {
        return {
          conferences: [],
        };
      }

      const processedConferences = res.conferences.map(
        (item: Conference, index: number) => {
          const startTime = new Date(item.start_time);

          const match = item.title.match(/^\[(.*?)\]\s*(.*)$/);
          const tag = match ? match[1] : undefined;
          const title = match ? match[2] : item.title;

          return {
            id: item.id,
            tag,
            title,
            date: startTime.getDate(),
            day: startTime.toLocaleDateString('en-US', { weekday: 'long' }),
            month: startTime
              .toLocaleDateString('en-US', { month: 'short' })
              .toUpperCase(),
            time: startTime.toLocaleTimeString('en-US', {
              hour: 'numeric',
              minute: '2-digit',
              hour12: true,
            }),
            color: calendarItemColors[index] || '#FFFFFF',
          };
        },
      );

      return { conferences: processedConferences };
    },
  });
};
